const STORAGE_KEY = 'tradeSoundEnabled';

export function isTradeSoundEnabled() {
  const saved = localStorage.getItem(STORAGE_KEY);
  if (saved === null) return true;
  return saved === 'true';
}

export function setTradeSoundEnabled(enabled) {
  localStorage.setItem(STORAGE_KEY, enabled ? 'true' : 'false');
}

let audioCtx = null;

function getAudioContext() {
  const AudioCtx = window.AudioContext || window.webkitAudioContext;
  if (!AudioCtx) return null;
  if (!audioCtx || audioCtx.state === 'closed') {
    audioCtx = new AudioCtx();
  }
  if (audioCtx.state === 'suspended') {
    audioCtx.resume().catch(() => {});
  }
  return audioCtx;
}

function playTone(ctx, frequency, startTime, duration, volume) {
  const oscillator = ctx.createOscillator();
  const gain = ctx.createGain();
  oscillator.type = 'sine';
  oscillator.frequency.setValueAtTime(frequency, startTime);
  gain.gain.setValueAtTime(0.0001, startTime);
  gain.gain.exponentialRampToValueAtTime(volume, startTime + 0.02);
  gain.gain.exponentialRampToValueAtTime(0.0001, startTime + duration);
  oscillator.connect(gain);
  gain.connect(ctx.destination);
  oscillator.start(startTime);
  oscillator.stop(startTime + duration + 0.03);
}

export function playTradeSound(kind = 'buy') {
  if (!isTradeSoundEnabled()) return;

  try {
    const ctx = getAudioContext();
    if (!ctx) return;
    const now = ctx.currentTime;
    if (kind === 'sell') {
      playTone(ctx, 523.25, now, 0.12, 0.2);
      playTone(ctx, 392.0, now + 0.1, 0.16, 0.16);
    } else {
      playTone(ctx, 523.25, now, 0.1, 0.2);
      playTone(ctx, 659.25, now + 0.09, 0.16, 0.16);
    }
  } catch (error) {
    // Ignore audio errors (autoplay restrictions, missing API)
  }
}
